import Home from "./presenters/home";
import Test from "./presenters/test";
import TestDone from "./presenters/testDone";
import TestForm from "./presenters/testForm";
import {
  BrowserRouter as Router,
  Route,
} from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  /**Renders different components depeding on path */
  
  return <div className="app">
    <Router>
      <div>
          <Route exact path="/" component={Home} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/test" component={Test} />
          <Route exact path="/test/" component={Test} />
          <Route exact path="/test/done" component={TestDone} />
          <Route exact path="/test/form" component={TestForm} />
          
      </div> 
    </Router>
  </div>;
}

export default App;
